import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  Autocomplete,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";

import Box from "@mui/material/Box";
import { ButtonGroup, Input } from "@mui/material";
import { Button } from "semantic-ui-react";
import { Divider } from "semantic-ui-react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import { ENTORNO } from "../../../utils/constantes";
import {
  calcular_trayecto,
  cancelar,
  nuevo_viaje,
  si,
  vas_a_confirmar_el_viaje,
  viaje_registrado_con_exito,
  tienes_un_viaje_en_curso,
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo,
  resumen_del_viaje,
  destino,
  partida,
  trayecto,
  resumen,
  confirmar,
  metodo_de_pago,
  falta_agregar_metodo_de_pago_valido,
  pago,
  selecciona_punto_de_partida,
  selecciona_punto_destino,
  para_continuar_debes_activar_el_gps,
  punto_de_partida,
  punto_destino,
  buscar_calle,
  tu_ubicacion,
  cargando_mapa,
  calcular,
  borrar,
  centrar,
} from "../../../utils/traductor";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PlaceIcon from "@mui/icons-material/Place";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  getIdioma,
  getemail,
  getpassword,
  setmenuAbajoSeleccionado,
  setmenuLateralSeleccionado,
  getNombre,
  getApellido,
  getid,
  getTokenNotificacion,
  setPoolingActivado,
  setViajeId,
  getGeolocalizacion,
} from "../../../utils/variablesLocales";
import Swal from "sweetalert2";
import { estiloColores } from "../../../estilos/colores";
import { apiListaBlanca } from "../../../api/listaBlanca";
import { apiViaje } from "../../../api/viaje";
import { apiSubastador } from "../../../api/subastador";
import { apiMobbex } from "../../../api/mobbex";
import { apiPrecio } from "../../../api/precio";
import { apiUsuario } from "../../../api/usuario";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";
import { CheckCircleOutline, Margin } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import { Segment, Label, Form, Icon } from "semantic-ui-react";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";
import { styled } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";

const apilistablanca = new apiListaBlanca();
const apiusuario = new apiUsuario();
const apiprecio = new apiPrecio();
const apimobbex = new apiMobbex();
const apiviaje = new apiViaje();
const apisubastador = new apiSubastador();

const StyledFab = styled(Fab)({
  position: "absolute",
  zIndex: 1,
  top: -30,
  left: 0,
  right: 0,
  margin: "0 auto",
});

export function NuevoViaje4() {
  const [openBackDrop, setopenBackDrop] = React.useState(false);
  const handleCloseBackDrop = () => {
    setopenBackDrop(false);
  };
  const handleOpen = () => {
    setopenBackDrop(true);
  };

  const girarPartidaDestino = async () => {
    try {
      const partidaValor = partidaRef.current.querySelector("input").value;
      const destinoValor = destinoRef.current.querySelector("input").value;

      const partidaValorAux = destinoRef.current.querySelector("input").value;
      const destinoValorAux = partidaRef.current.querySelector("input").value;

      partidaRef.current.querySelector("input").value = partidaValorAux;
      destinoRef.current.querySelector("input").value = destinoValorAux;

      if (partidaValor !== "" && destinoValor !== "") {
        CalcularRuta();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      //cargar valor inicial en punto de partida, en caso que exista
      // if (!partidaRef) {
      //   partidaRef.current.querySelector("input").value = PartidaUbicacion;
      // }

      //verificar si usuario se encuentra en lista blanca,
      //caso contrario NO le permito crear nuevos viajes
      const resultadoListaBlanca = await apilistablanca.obtener(getemail());

      if (parseInt(resultadoListaBlanca.length) === 0) {
        navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
      } else {
      }
    })();
  }, []);

  /////////////////////////

  ///////////////////////////////////
  //notificacion snackbar informacion de accion
  const [MensajeInformacion, setMensajeInformacion] = useState("");
  const [openInformacion, setOpenInformacion] = React.useState(false);

  // const handleCloseInformacion = (
  //   event: React.SyntheticEvent | Event,
  //   reason?: string
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpenInformacion(false);
  // };

  const handleCloseInformacion = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInformacion(false);
  };
  ///////////////////////////////////

  const navigate = useNavigate();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAMqRtQO0710z-o3NJGNXZtCpfUBObWJe4",
    libraries: ["places"],
  });

  const [map, setMap] = useState(/** @type google.maps.Map */ (null));
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [Kms, setKms] = useState("");
  const [Min, setMin] = useState("");
  const [PrecioBase, setPrecioBase] = useState(0);
  const [Localidad, setLocalidad] = useState(null);
  const [Provincia, setProvincia] = useState(null);

  const [PartidaUbicacion, setPartidaUbicacion] = useState(
    getGeolocalizacion().split("|")[5] === "true"
      ? getGeolocalizacion().split("|")[6]
      : ""
  );

  const [DestinoUbicacion, setDestinoUbicacion] = useState("");
  const [LatitudPartida, setLatitudPartida] = useState(null);
  const [LongitudPartida, setLongitudPartida] = useState(null);
  const [LatitudDestino, setLatitudDestino] = useState(null);
  const [LongitudDestino, setLongitudDestino] = useState(null);

  /** @type React.MutableRefObject<HTMLInputElement> */
  const partidaRef = useRef();
  /** @type React.MutableRefObject<HTMLInputElement> */
  const destinoRef = useRef();

  if (!isLoaded) {
    return <div style={{ textAlign: "center" }}>{cargando_mapa}</div>;
  }

  async function CalcularRuta() {
    const partidaValor = partidaRef.current.querySelector("input").value;
    const destinoValor = destinoRef.current.querySelector("input").value;

    setPartidaUbicacion(partidaValor.replace(" Province", ""));
    setDestinoUbicacion(destinoValor.replace(" Province", ""));

    //obtengo localidad y provincia
    let LocalidadAux = "";

    geocodeByAddress(partidaValor.replace(" Province", "")).then((results) => {
      setLocalidad(results[0].address_components[3].long_name);
      setProvincia(results[0].address_components[4].long_name);

      if (
        results[0].address_components[4].long_name === "Córdoba" &&
        results[0].address_components[3].long_name === "Capital"
      ) {
        setLocalidad("Córdoba");

        LocalidadAux = "Córdoba";
      } else {
        LocalidadAux = results[0].address_components[3].long_name;
      }
    });

    //obtengo latitud y longitud de partida
    geocodeByAddress(partidaValor.replace(" Province", ""))
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        setLatitudPartida(lat);
        setLongitudPartida(lng);
      });

    //obtengo latitud y longitud de destino
    geocodeByAddress(destinoValor.replace(" Province", ""))
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        setLatitudDestino(lat);
        setLongitudDestino(lng);
      });

    if (partidaRef.current.value === "" || destinoRef.current.value === "") {
      return;
    }

    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService();

    //calculo ruta
    const results = await directionsService.route({
      origin: partidaValor,
      destination: destinoValor,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
    });

    setKms(
      results.routes[0].legs[0].distance.text.replace(" ", "").replace("km", "")
    );

    setMin(
      results.routes[0].legs[0].duration.text
        .replace(" ", "")
        .replace("mins", "")
    );

    const KmsAux = results.routes[0].legs[0].distance.text
      .replace(" ", "")
      .replace("km", "");

    if (
      KmsAux !== undefined &&
      KmsAux !== null &&
      KmsAux !== "" &&
      KmsAux !== "0" &&
      LocalidadAux !== undefined &&
      LocalidadAux !== null &&
      LocalidadAux !== ""
    ) {
      let respuestaPrecioBase = await apiprecio.obtenerPrecioBase(
        LocalidadAux,
        KmsAux
      );

      if (
        respuestaPrecioBase.Estado !== undefined &&
        respuestaPrecioBase.Estado !== null
      ) {
        if (respuestaPrecioBase.Estado === "Ok") {
          setPrecioBase(respuestaPrecioBase.PrecioBase);
        }
      }
    }

    setDirectionsResponse(results);
  }

  function LimpiarRuta() {
    setDirectionsResponse(null);

    setPartidaUbicacion("");
    setDestinoUbicacion("");
    setLatitudPartida("");
    setLongitudPartida("");
    setLatitudDestino("");
    setLongitudDestino("");

    setKms("");
    setMin("");
    setPrecioBase("0");

    setLocalidad("");
    setProvincia("");

    partidaRef.current.value = "";
    destinoRef.current.value = "";
  }

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  const containerStyle = {
    width: "100%",
    marginTop: "30px",
    height: "90vh",
    marginLeft: "-1px",
    marginRight: "-1px",
    marginBottom: "0px",
    zIndex: "10",
  };

  const inputStylePartida = {
    boxSizing: "border-box",
    border: "1px solid transparent",
    width: "92%",
    height: "38px",
    padding: "0 12px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
    position: "absolute",
    right: "10px",
    left: "10px",
    top: "20px",
    backgroundColor: "white",
  };

  const inputStyleDestino = {
    boxSizing: "border-box",
    border: "1px solid transparent",
    width: "92%",
    height: "38px",
    padding: "0 12px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
    position: "absolute",
    right: "10px",
    left: "10px",
    top: "58px",
    backgroundColor: "white",
  };

  const Confirmar = async () => {
    if (
      Kms !== undefined &&
      Kms !== "undefined" &&
      Kms !== null &&
      Kms !== "null" &&
      Kms !== "0" &&
      Kms !== 0 &&
      Min !== undefined &&
      Min !== "undefined" &&
      Min !== null &&
      Min !== "null" &&
      Min !== "0" &&
      Min !== 0 &&
      PrecioBase !== undefined &&
      PrecioBase !== "undefined" &&
      PrecioBase !== null &&
      PrecioBase !== "null" &&
      PrecioBase !== "0" &&
      PrecioBase !== 0
    ) {
      Swal.fire({
        title: vas_a_confirmar_el_viaje,
        text: "",
        // type: "confirm",
        showCancelButton: true,
        confirmButtonText: si,
        confirmButtonColor: estiloColores.Azul,
        cancelButtonText: cancelar,
        cancelButtonColor: estiloColores.Gris,
      }).then((result) => {
        if (result.value) {
          ConfirmarAccion(
            PartidaUbicacion,
            LatitudPartida,
            LongitudPartida,
            DestinoUbicacion,
            LatitudDestino,
            LongitudDestino,
            Kms,
            Min,
            PrecioBase,
            Localidad,
            Provincia
          );
        }
      });
    }
  };

  const ConfirmarAccion = async (
    PartidaUbicacion,
    LatitudPartida,
    LongitudPartida,
    DestinoUbicacion,
    LatitudDestino,
    LongitudDestino,
    Kms,
    Min,
    PrecioBase,
    Localidad,
    Provincia
  ) => {
    let PasajeroAux = getNombre() + " " + getApellido();

    let VerEnGoogleMapsAux =
      "https://www.google.com.ar/maps/dir/Calle+" +
      PartidaUbicacion.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Localidad.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Provincia.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      "/" +
      DestinoUbicacion.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Localidad.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Provincia.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n");

    const respuestaViaje = await apiviaje.nuevo(
      PartidaUbicacion,
      LatitudPartida,
      LongitudPartida,
      DestinoUbicacion,
      LatitudDestino,
      LongitudDestino,
      Kms,
      Min,
      PrecioBase,
      Localidad,
      Provincia,
      PasajeroAux,
      VerEnGoogleMapsAux,
      getTokenNotificacion()
    );

    if (respuestaViaje._id !== undefined) {
      //muestro snackbar
      setMensajeInformacion(viaje_registrado_con_exito);
      setOpenInformacion(true);

      //muestro back-drop
      setopenBackDrop(true);

      setmenuAbajoSeleccionado("Inicio");
      setmenuLateralSeleccionado("");

      const ViajeId = respuestaViaje._id;

      //creo boton de pago
      await apimobbex.checkout(ViajeId, getIdioma());

      //solicito subasta
      await apisubastador.subastar(ViajeId);

      setViajeId(ViajeId);

      navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
    }
  };

  return (
    <div>
      <AppBar style={{ background: "#DC030E" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            onClick={navigateToInicio}
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {nuevo_viaje}
          </Typography>
          <img
            src={logoLocalPoint}
            style={{ marginTop: "1px" }}
            width="75"
            alt="Logo"
          />
        </Toolbar>
      </AppBar>

      <div
        id="divPartidaDestino"
        style={{
          position: "absolute",
          marginTop: "20px",
          backgroundColor: "white",
          left: "0",
          right: "0",
          margin: "15px",
          marginLeft: "15px",
          padding: "0px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
          zIndex: "30",
        }}
      >
        <Autocomplete>
          <Input
            style={{ marginLeft: "20px", marginTop: "15px", width: "83%" }}
            type="text"
            placeholder={selecciona_punto_de_partida}
            ref={partidaRef}
            onKeyDown={(e) => {
              e.key === "Enter" && e.preventDefault();
            }}
            onFocus={(e) => e.target.select()}
            // value={PartidaUbicacion}
            // onChange={(e, data) => {
            //   setPartidaUbicacion(e.target.value);
            // }}
          />
        </Autocomplete>
        <br></br>
        <Autocomplete
        // onPlaceChanged={onPlaceChanged} onLoad={onLoad}
        >
          <Input
            style={{ marginLeft: "20px", width: "83%" }}
            type="text"
            placeholder={selecciona_punto_destino}
            ref={destinoRef}
            onKeyDown={(e) => {
              e.key === "Enter" && e.preventDefault();
            }}
            onFocus={(e) => e.target.select()}
            // value={DestinoUbicacion}
            // onChange={(e, data) => {
            //   setDestinoUbicacion(e.target.value);
            // }}
          />
        </Autocomplete>
        <br></br>
        <div
          style={{
            textAlign: "center",
            marginTop: "-10px",
            marginBottom: "10px",
          }}
        >
          <Button
            style={{ backgroundColor: "#153B5E", color: "white" }}
            type="submit"
            onClick={CalcularRuta}
          >
            {calcular}
          </Button>

          <IconButton
            style={{
              color: "#153B5E",
              position: "absolute",
              marginTop: "-60px",
              right: "-5px",
            }}
            onClick={() => girarPartidaDestino()}
          >
            <ImportExportIcon fontSize="large" />
          </IconButton>

          {/* <Button
            style={{ backgroundColor: "#153B5E", color: "white" }}
            onClick={LimpiarRuta}
          >
            {borrar}
          </Button>
          <Button
            style={{ backgroundColor: "#153B5E", color: "white" }}
            onClick={() => {
              map.panTo({
                lat: parseFloat(getGeolocalizacion().split("|")[3]),
                lng: parseFloat(getGeolocalizacion().split("|")[4]),
              });
              map.setZoom(15);
            }}
          >
            {centrar}
          </Button> */}
        </div>
      </div>

      <GoogleMap
        center={{
          lat: parseFloat(getGeolocalizacion().split("|")[3]),
          lng: parseFloat(getGeolocalizacion().split("|")[4]),
        }}
        zoom={getGeolocalizacion().split("|")[5] === "true" ? 15 : 10}
        options={{
          disableDefaultUI: true,
        }}
        mapContainerStyle={containerStyle}
        onLoad={(map) => setMap(map)}
      >
        {/* <Marker
            position={{
              lat: parseFloat(getGeolocalizacion().split("|")[3]),
              lng: parseFloat(getGeolocalizacion().split("|")[4]),
            }}
          /> */}
        {directionsResponse && (
          <DirectionsRenderer directions={directionsResponse} />
        )}
      </GoogleMap>

      <div
        id="divResumenViaje"
        name="divResumenViaje"
        style={{
          textAlign: "center",
          position: "absolute",
          backgroundColor: "white",
          left: "0",
          right: "0",
          bottom: "0",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          paddingTop: "10px",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
          zIndex: "20",
        }}
      >
        <b>{resumen_del_viaje}</b>
        <div>
          <Divider></Divider>
        </div>
        <div
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "-15px",
          }}
        >
          <b>{destino}</b>: {DestinoUbicacion}
        </div>
        <br></br>
        <Form.Field style={{ textAlign: "center" }}>
          <Label
            style={{
              backgroundColor: "white",
              color: "#153B5E",
              borderColor: "#153B5E",
            }}
          >
            <Icon name="map outline" />
            {Kms} Kms
          </Label>
          <Label
            style={{
              backgroundColor: "white",
              color: "#153B5E",
              borderColor: "#153B5E",
            }}
          >
            <Icon name="clock outline" />
            {Min} Min
          </Label>
          <Label
            style={{
              backgroundColor: "white",
              color: "#153B5E",
              borderColor: "#153B5E",
            }}
          >
            <Icon name="dollar sign" />
            {PrecioBase}
          </Label>
        </Form.Field>
        <br></br>
        {Kms !== undefined &&
        Kms !== "undefined" &&
        Kms !== null &&
        Kms !== "null" &&
        Kms !== "0" &&
        Kms !== 0 &&
        Min !== undefined &&
        Min !== "undefined" &&
        Min !== null &&
        Min !== "null" &&
        Min !== "0" &&
        Min !== 0 &&
        PrecioBase !== undefined &&
        PrecioBase !== "undefined" &&
        PrecioBase !== null &&
        PrecioBase !== "null" &&
        PrecioBase !== "0" &&
        PrecioBase !== 0 ? (
          <Button
            onClick={Confirmar}
            style={{
              backgroundColor: "#153B5E",
              color: "white",
              height: "48px",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              fontSize: "large",
            }}
            attached="bottom"
          >
            {confirmar}
          </Button>
        ) : (
          <div></div>
        )}
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
        onClick={handleCloseBackDrop}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>

      <Snackbar
        open={openInformacion}
        onClose={handleCloseInformacion}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={<CheckCircleOutline fontSize="inherit" />}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {MensajeInformacion}
        </Alert>
      </Snackbar>
    </div>
  );
}
